<template>
  <div id="page">
    <b-container>
      <div
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="busy"
        infinite-scroll-distance="10"
      >
        <div v-for="(item, index) in orders" :key="index">
          <b-card class="mb-2">
            <b-container class="text-left">
              <b-row style="margin-top: 4px">
                <b-col>订单号</b-col>
              </b-row>
              <b-row>
                <b-col
                  ><b>{{ item.orderNo }}</b></b-col
                >
              </b-row>

              <b-row style="margin-top: 4px">
                <b-col>订单状态</b-col>
              </b-row>
              <b-row>
                <b-col
                  ><b>
                    <font color="red">{{ item.orderStatus }}</font>
                  </b></b-col
                >
              </b-row>

              <b-row style="margin-top: 4px">
                <b-col>申请日期</b-col>
              </b-row>
              <b-row>
                <b-col
                  ><b>{{ item.orderDateTime }}</b></b-col
                >
              </b-row>

              <b-row style="margin-top: 8px">
                <b-col
                  v-show="
                    item.orderStep != 0 ||
                    (item.orderStep == 0 && item.orderStatsNo == 5)
                  "
                >
                  <b-button variant="danger" block @click="itemClick(item)"
                    >详情</b-button
                  >
                </b-col>
              </b-row>
            </b-container>
          </b-card>
        </div>
      </div>

      <!-- loading toast -->
      <div v-show="loading">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <i class="weui-loading weui-icon_toast"></i>
          <p class="weui-toast__content">加载中</p>
        </div>
      </div>

      <div v-show="showToast">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
          <p class="weui-toast__content">{{ toastMsg }}</p>
        </div>
      </div>

      <b-modal
        ok-only
        ref="model_error"
        title="提示"
        @ok="handleOk()"
        ok-title="确定"
      >
        <p class="my-4">{{ errorMsg }}</p>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
var config = require("../../common/config.js");
export default {
  name: "OrderList_schtnf",
  data() {
    return {
      projectName: "DIY",
      orders: [],
      loading: false,
      showToast: false,
      toastMsg: "",
      pageIndex: 1,
      pageSize: 4,
      queryOrderParam: null,
      hasMoreData: false,
      busy: false,
      errorMsg: "",
    };
  },
  watch: {
    hasMoreData: function (newvalue, oldvalue) {
      console.log("hasMoreData new:" + newvalue + "," + "old:" + oldvalue);
    },
  },
  methods: {
    handleOk: function () {
      this.$router.go(-1);
    },
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    loadMore: function () {
      this.busy = true;
      if (this.hasMoreData) {
        this.queryOrder();
      }
    },
    showToastMsg: function (msg) {
      this.toastMsg = msg;
      let that = this;
      that.showToast = true;
      setTimeout(function () {
        that.showToast = false;
      }, 2000);
    },
    showLoading: function () {
      this.loading = true;
    },
    hideLoading: function () {
      this.loading = false;
    },
    itemClick: function (item) {
      var obj = {
        projectName: this.projectName,
        order: item,
      };
      var orderItem = JSON.stringify(obj);
      // {
      //   "orderNo": "01251806910893002752",
      //   "orderDateTime": "2020-05-30 17:27:01",
      //   "orderStatus": "未支付",
      //   "orderStatsNo": 5,
      //   "courierCompany": "",
      //   "trackNumber": "",
      //   "orderType": "1",
      //   "price": 1,
      //   "auditFailCause": null,
      //   "modelType": 0,
      //   "modelClass": 0,
      //   "backgroundColor": "201C",
      //   "cardClass": 1,
      //   "address": null,
      //   "orderStep": 0,
      //   "cardTypeName": "借记卡",
      //   "thumbnailFileUrl": null
      // }
      /* if (item.orderStep == 0 && item.orderStatsNo == 5) {
          //支付页面
          this.toOrderPay(item);
        } else {
          //订单详情
          this.$router.push({
            name: 'OrderDetails_schtnf',
            params: {
              orderItem: orderItem
            }
          })
        } */

      this.$router.replace({
        name: "OrderDetails_schtnf",
        params: {
          orderItem: orderItem,
        },
      });
    },
    queryOrder: function () {
      /* "bankCodeList": {
          "bankCode": "0051",
          "serialList": [
            "234c536475bd470991fdfb966fe686b7",
            "4530dd224de0446eac8dc42acd52d526",
            "f7d8eaacc8f249dda67bb7b7e2421f65",
            "6532d2664ff543a68fbbbade2e8059b3",
            "9ba59cac637f48df9baa9e09ffa1ed8a"
          ]
        },
        "pageIndex": 0,
        "pageSize": 10 */

      var that = this;
      that.showLoading();
      axios
        .post(config.config_schtnf.queryOrder, {
          bankCode: config.config_schtnf.bankCode,
          serialList: that.queryOrderParam,
          pageIndex: that.pageIndex,
          pageSize: that.pageSize,
        })
        .then(function (response) {
          /* {
              "code": 0,
              "message": null,
              "projectName": "DIY",
              "orderModelList": [{
                "orderNo": "01222404618637029376",
                "orderDateTime": "2020-03-10 14:12:50",
                "orderStatus": "制卡完成",
                "orderStatsNo": 8,
                "courierCompany": "",
                "trackNumber": "",
                "orderType": "1",
                "price": 1,
                "auditFailCause": null,
                "modelType": 0,
                "modelClass": 0,
                "backgroundColor": "201C",
                "cardClass": 1,
                "address": "北京市西城区新盛大厦B-8层",
                "orderStep": 3,
                "cardTypeName": "借记卡",
                "thumbnailFileUrl": "group1/M00/00/03/MgAAaF5nL-KAcaymAAHTkobYNwU311.png"
              }]
            } */
          that.hideLoading();
          that.busy = false;
          console.log(response);
          var data = response.data;
          var dataString = JSON.stringify(data);
          console.log(dataString);

          if (data.code == 0) {
            that.pageIndex++;
            console.log("pageIndex:" + that.pageIndex);
            let tempOrders = data.orderModelList;
            that.orders.push.apply(that.orders, tempOrders);
            console.log("tempOrders.length:" + tempOrders.length);
            if (tempOrders.length == 4) {
              that.hasMoreData = true;
            } else {
              that.hasMoreData = false;
            }
          } else {
            if (that.pageIndex == 1) {
              that.errorMsg = data.message;
              that.showErrorMsg();
            } else {
              that.showToastMsg(data.message);
            }

            that.hasMoreData = false;
          }
          console.log("hasMoreData:" + that.hasMoreData);
        })
        .catch(function (error) {
          that.hideLoading();
          that.busy = false;
          that.hasMoreData = false;
          console.log(error);
        });
    },
  },
  mounted: function () {
    /* {
        "projectName": "DIY",
        "orders": [{
          "orderNo": "01222404618637029376",
          "orderDateTime": "2020-03-10 14:12:50",
          "orderStatus": "制卡完成",
          "orderStatsNo": 8,
          "courierCompany": "",
          "trackNumber": "",
          "orderType": "1",
          "price": 1,
          "auditFailCause": null,
          "modelType": 0,
          "modelClass": 0,
          "backgroundColor": "201C",
          "cardClass": 1,
          "address": "北京市西城区新盛大厦B-8层",
          "orderStep": 3,
          "cardTypeName": "借记卡",
          "thumbnailFileUrl": "group1/M00/00/03/MgAAaF5nL-KAcaymAAHTkobYNwU311.png"
        }]
      } */
    var result = this.$route.params.bankSerialObj;
    console.log("result:" + result);
    if (result != undefined) {
      var obj = JSON.parse(result);
      this.queryOrderParam = obj;
      console.log("queryOrderParam:" + this.queryOrderParam);
      this.queryOrder();
    }
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/sichuantianfubank/OrderList_schtnf.vue